/* eslint-disable import/extensions */
/* eslint-disable no-underscore-dangle */
// Force all timezone-aware libraries to use the IANA data bundled with the
// application instead of timezone rules supplied by the browser or OS.
import browserTimezone from './browserTimezone';
import '@formatjs/intl-datetimeformat/polyfill-force.js';
import '@formatjs/intl-datetimeformat/locale-data/en.js';
import '@formatjs/intl-datetimeformat/locale-data/fr.js';
import '@formatjs/intl-datetimeformat/add-all-tz.js';

export const setPolyfillDefaultTimeZone = timezone => {
  if (
    !timezone ||
    typeof Intl.DateTimeFormat.__setDefaultTimeZone !== 'function'
  ) {
    return;
  }

  try {
    Intl.DateTimeFormat.__setDefaultTimeZone(timezone);
  } catch (error) {
    // Browsers can report names absent from the bundled data, such as
    // Etc/Unknown. Keep the polyfill's UTC default instead of blocking startup.
    if (!(error instanceof RangeError)) throw error;
  }
};

// The browser may identify the user's zone, but the polyfill calculates that
// zone's offsets from the bundled IANA database.
setPolyfillDefaultTimeZone(browserTimezone);
